import * as React from "react";
import { useState, useLayoutEffect } from "react";
import { useSearchParams } from "react-router-dom";
// Services
import { getAppPQRToken } from "../../services/auth";
import {
  getAllCities,
  getAllCountries,
  getAllGenres,
  getAllOrigins,
  getAllTrainingGoals,
} from "../../services/ApiGeneralService";
// Components
import Error from "../Error";
import { CreateCrmLead } from "./Forms/CreateCrmLead";
import { getDocumentTypes } from "services/payments";

const maxCoutesieDate = new Date('2024-06-19 00:00:00')

const CrmLead = ({ isMobile, setCurrentBrand }) => {
  const [searchParams] = useSearchParams();
  // States for data query params
  const [isLoading, setIsLoading] = useState(true);
  const [venue, setVenue] = useState(null);
  const [brand, setBrand] = useState(null);
  const [source,setSource] = useState(null);
  // States for data component
  const [identificationTypes, setIdentificationTypes] = useState([]);
  // States for fetch
  const [genders, setGenders] = useState([]);
  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  const [trainingGoals, setTrainingGoals] = useState([]);
  const [origins, setOrigins] = useState([]);
  const [error, setError] = useState(false);
  const [returnParam, setReturnParam] = useState(0);

  const isCourtesie = searchParams.get("c") == process.env.REACT_APP_PUBLIC_COURTESIE_UUID

  useLayoutEffect(() => {
    getAuthToken();
    const brand = searchParams.get("b");
    const venue = searchParams.get("v");
    const source = searchParams.get("s");
    const returnParam = searchParams.get("r");
    setCurrentBrand(brand);
    setBrand(brand);
    setVenue(venue);
    setSource(source);
    setReturnParam(returnParam ?? 0);
    setItemLocalStorage("current_brand", brand);
    setItemLocalStorage("venue_id", venue);
  }, []);

  const getAuthToken = async () => {
    try {
      const response = await getAppPQRToken();
      if (response.data) {
        const data = response.data;
        setItemLocalStorage("access_token_bt", data.access_token);
        setItemLocalStorage("refresh_token_bt", data.access_token);
        setItemLocalStorage("access_token_bt_pqr", data.access_token);
        setItemLocalStorage("refresh_token_bt_pqr", data.access_token);
        await handlerGetData();
        handlerSetIdentificationTypes();
      } else {
        isError();
      }
    } catch (err) {
      isError();
    }
  };

  const handlerGetData = async () => {
    //Get all data to select
    const responses = await Promise.all([
      getAllGenres(),
      getAllCountries(),
      getAllCities(),
      getAllTrainingGoals(),
      getAllOrigins(),
    ]);

    for (let i = 0; i < 5; i++) {
      if (responses[i].data.status === "error") {
        isError();
      }
    }

    const genders = responses[0].data.data;
    const countries = responses[1].data.data;
    const cities = responses[2].data.data;
    const trainingGoals = responses[3].data.data;
    const origins = responses[4].data.data;
    setGenders(genders);
    setCountries(countries);
    setCities(cities);
    setTrainingGoals(trainingGoals);
    handlerSetOrigins(origins);
    setIsLoading(false);
  };

  const handlerSetIdentificationTypes = () => {
    //get document_types by brand
    getDocumentTypes()
      .then(({data}) => {
        setIdentificationTypes(data?.data);
      })
      .catch(console.error)
  };

  const setItemLocalStorage = (name = "", value = "") => {
    localStorage.setItem(name, value);
  };

  const isError = () => {
    setError(true);
  };

  const handlerSetOrigins = (origins = []) => {
    if (origins.length) {
      origins.push({ id: 999, name: "Otro" });
    }
    setOrigins(origins);
  };

  return (
    <React.Fragment>
      {isLoading && <Error hasLoader />}
      {!isLoading && error && (
        <Error
          customTitle="¡Ups! Al parecer hubo un error"
          customMessage="Inténtalo de nuevo más tarde"
        />
      )}
      {
        isCourtesie && Date.now() > maxCoutesieDate ?
          <Error
            customTitle="¡Ups! Ya no es posible registrarse"
            customMessage=" "
            linkButton={""}
          />
        :
        <>
          {!isLoading && !error && (
            <CreateCrmLead
              brand={brand}
              venue={venue}
              source={source}
              identificationTypes={identificationTypes}
              genders={genders}
              countries={countries}
              cities={cities}
              trainingGoals={trainingGoals}
              origins={origins}
              isMobile={isMobile}
              setCities={setCities}
              returnParam={returnParam}
              isCourtesie={isCourtesie}
            />
          )}
        </>

      }
    </React.Fragment>
  );
};

export default CrmLead;
